import axios from "axios"
import config from '../config'

function get(endpoint) {
  let url = `${config.api.root}/${endpoint}`
  return request({url, method:"GET"})
}

function post(endpoint, payload) {
  let url = `${config.api.root}/${endpoint}`
  return request({url, method:"POST", data:payload})
}

function request(options) {
  return new Promise((resolve, reject) => {
    let validatedStatus
    let request = axios({
      url: options.url,
      method: options.method,
      data: options.data,
      validateStatus: function(status) {
        validatedStatus = status
        return ((status >= 200 && status < 300) || status === 404) // || (status >= 400 && status < 500) //)
      }
    })
    request
      .then(({data}) => {
        switch(validatedStatus) {
          case 404:
            reject(data)
            break;
          default:
            resolve(data)
            break
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

export default {
  get,
  post
}